import { combineReducers } from 'redux';
import { language } from '../components/language/ducks/index';
import * as fromLanguage from '../components/language/ducks/index';
import { userProfile } from '../components/user/ducks/index';
import * as fromAuth from '../components/user/ducks/index';
import { configuration } from "../components/configuration/ducks/index";
import * as fromConfiguration from '../components/configuration/ducks/index';
import { securityQuestions } from "../components/security-questions/ducks/index";
import * as fromSecurityQuestions from '../components/security-questions/ducks/index'


const rootReducer = combineReducers({
  language,
  userProfile,
  configuration,
  securityQuestions
});

export default rootReducer;

export const getUserProfile = (state) => fromAuth.getUserProfile(state.userProfile);
export const getLanguage = (state) => fromLanguage.getLanguage(state.language);
export const isEnglishActive = (state) => fromLanguage.isEnglishActive(state.language);
export const isFrenchActive = (state) => fromLanguage.isFrenchActive(state.language);
export const getConfiguration = (state) => fromConfiguration.getConfiguration(state.configuration);
export const getSecurityQuestions = (state) => fromSecurityQuestions.getSecurityQuestions(state.securityQuestions);
